import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const HeaderHome_en = ({ isVisible }) => {
  const handleClick = (event) => {
    event.preventDefault(); // Prevent the default action
    console.log("Link click prevented!");
  };
  // const navigate = useNavigate();
  // const [language, setLanguage] = useState("fr");

  // //const langus = document.documentElement.lang;
  // const langtobe = document.documentElement.lang === "fr" ? "en" : "fr";

  // const toggleLanguage = (e) => {
  //   e.preventDefault();
  //   // setLanguage((langus) => (langus === "fr" ? "en" : "fr"));
  //   // setLanguagetobe((langus) => (langus === "fr" ? "en" : "fr"));
  //   const newLang = language === "fr" ? "en" : "fr";
  //   // Update the lang attribute directly
  //   document.documentElement.lang = newLang;
  //   navigate(langtobe === "en" ? "en" : "/");
  //   // Update the state
  //   setLanguage(newLang);
  // };
  return (
    <div style={{ display: isVisible ? "block" : "none" }}>
      {/*=================================
   header */}

      <header id="header" className="header default">
        <div className="topbar">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6 xs-mb-10">
                <div className="topbar-call text-center text-md-left">
                  <ul>
                    <li>
                      <i className="fa fa-envelope-o theme-color" />{" "}
                      <a
                        href="mailto:contact@sacemgroup.com"
                        style={{ fontSize: "15px" }}
                      >
                        contact@sacemgroup.com
                      </a>
                    </li>
                    {/*
                    <li>
                      <i className="fa fa-phone" />{" "}
                      <a href="tel:0021671966986">
                        {" "}
                        <span>+(216) 71 966 986 </span>{" "}
                      </a>{" "}
                    </li>
                    */}
                  </ul>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="topbar-social text-center text-md-right">
                  <ul>
                    <li>
                      <a
                        href="/en/carriers"
                        style={{ color: "white", fontSize: "15px" }}
                      >
                        Career
                      </a>
                    </li>
                    <li>
                      <a href="/en/pfebook" style={{ fontSize: "15px" }}>
                        PFE Book
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.facebook.com/sacemindustries/?locale=fr_FR"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ti-facebook" />
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://fr.linkedin.com/company/sacem-group"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ti-linkedin" />
                      </a>
                    </li>
                    {/* <li>
                      <a href="/">
                        <img
                          src="/assets/images/language icon/fr.png"
                          alt="fr"
                        />
                      </a>
                    </li> */}
                    <li>
                      <a
                        className="nav-link dropdown-toggle"
                        data-toggle="dropdown"
                        href="#"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span>EN&nbsp; </span>
                        <i className="fa fa-globe" />
                      </a>
                      <div
                        className="dropdown-menu "
                        x-placement="bottom-start"
                        style={{
                          position: "absolute",
                          transform: "translate3d(0px, 37px, 0px)",
                          top: 0,
                          left: 0,
                          willChange: "transform",
                          minWidth: "4rem",
                        }}
                      >
                        <ul
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          <li
                            style={{
                              marginRight: "0%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <a href="/" style={{ marginLeft: "0%" }}>
                              <img
                                src="/assets/images/language icon/fr.png"
                                alt="fr"
                              />
                            </a>
                          </li>
                          <li
                            style={{
                              marginRight: "0%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <a href="/en" style={{ marginLeft: "0%" }}>
                              <img
                                src="/assets/images/language icon/en.png"
                                alt="en"
                              />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    {/* <li>
                      <a href={language === "fr" ? "/en/" : "/"}>
                        <img
                          src={
                            langtobe === "fr"
                              ? "/assets/images/language icon/fr.png"
                              : "/assets/images/language icon/en.png"
                          }
                          alt="francais"
                          onClick={toggleLanguage}
                        />
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*=================================
   mega menu */}
        <div className="menu">
          <centre>
            {/* menu start */}
            <nav id="menu" className="mega-menu">
              {/* menu list items container */}
              <section className="menu-list-items" style={{ height: "90px" }}>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 col-md-12">
                      <ul className="menu-logo">
                        <li>
                          <a href="/en">
                            <img
                              id="logo_img"
                              src="/assets/images/logos/logo1.png"
                              alt="SACEM Industries"
                            />{" "}
                          </a>
                        </li>
                      </ul>
                      {/* menu logo */}

                      {/* menu links */}
                      <div className="menu-bar">
                        <ul className="menu-links">
                          {/* HOME */}
                          <li>
                            <a href="/en" style={{ fontSize: "18px" }}>
                              Home{" "}
                            </a>
                          </li>
                          <li>
                            <a
                              href="/en/#/"
                              onClick={handleClick}
                              style={{ fontSize: "18px" }}
                            >
                              {" "}
                              Entreprise{" "}
                              <i className="fa fa-angle-down fa-indicator" />
                            </a>
                            {/* drop down multilevel  */}
                            <div className="drop-down-multilevel">
                              <ul>
                                <li>
                                  <a
                                    href="/en/presentation"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <i className="fa fa-television" />
                                    Presentation{" "}
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="/en/news"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <i className="fa fa-newspaper-o" />{" "}
                                    News{" "}
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="/en/history"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <i className="fa fa-history" /> History{" "}
                                  </a>
                                </li>
                                {/**<li>
                                  <a href="/en/csr">
                                    <i className="fa fa-handshake-o" /> CSR{" "}
                                  </a>
                                </li> */}

                                <li>
                                  <a
                                    href="/en/certificats"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <i className="fa fa-certificate" />{" "}
                                    Certification{" "}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </li>
                          <li>
                            <a
                              href="/en/Sustainability"
                              style={{ fontSize: "18px" }}
                            >
                              Sustainability
                            </a>
                          </li>
                          <li>
                            <a href="/en/products" style={{ fontSize: "18px" }}>
                              Products{" "}
                              <i className="fa fa-angle-down fa-indicator" />
                            </a>
                            <ul className="drop-down-multilevel left-side">
                              <li>
                                <a
                                  href="/en/transformer"
                                  style={{ fontSize: "16px" }}
                                >
                                  Transformers
                                  <i className="ti-plus fa-indicator" />
                                </a>
                                {/* drop down second level */}
                                <ul className="drop-down-multilevel left-side">
                                  <li>
                                    <a
                                      href="/en/distribution_transformer_24"
                                      style={{ fontSize: "15px" }}
                                    >
                                      <i className="ti-plus fa-indicator" />
                                      Three-phase distribution transformers
                                    </a>
                                    {/* drop down third level */}
                                    <ul className="drop-down-multilevel left-side">
                                      <li>
                                        <a
                                          href="/en/distribution_transformer_24"
                                          style={{ fontSize: "14px" }}
                                        >
                                          Distribution transformer Three-phase
                                          class 24KV
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          href="/en/distribution_transformer_36"
                                          style={{ fontSize: "14px" }}
                                        >
                                          Distribution transformer Three-phase
                                          class 36KV
                                        </a>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <a
                                      href="/en/Three_phase_POWER_Transformer"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Three-phase POWER Transformers
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/en/single_phase_transformer"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Single Phase Transformers
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/en/Special_Transformers"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Special Transformers
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/en/photovoltaic_transformers"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Photovoltaic Transformers
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a
                                  href="/en/MV-BT_panel"
                                  style={{ fontSize: "16px" }}
                                >
                                  MV/LV Switchboard
                                  <i className="ti-plus fa-indicator" />
                                </a>
                                {/* drop down second level */}
                                <ul className="drop-down-multilevel right-side">
                                  <li>
                                    <a
                                      href="/en/aispanel"
                                      style={{ fontSize: "15px" }}
                                    >
                                      AIS Switchgear 36KV
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/en/Transformer_Protection_Box"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Transformer Protection Box
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/en/eems"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Energy Management System
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/en/activefilter"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Active anti-harmonic filter
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                  <li>
                                    <a
                                      href="/en/battery_of_capacitors"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Capacitor Bank
                                    </a>
                                    {/* drop down third level */}
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>

                          <li>
                            <a
                              href="/en/#/"
                              onClick={handleClick}
                              style={{ fontSize: "18px" }}
                            >
                              SERVICES{" "}
                              <i className="fa fa-angle-down fa-indicator" />{" "}
                            </a>
                            <ul className="drop-down-multilevel left-side">
                              <li>
                                {" "}
                                <a
                                  href="/en/services"
                                  style={{ fontSize: "16px" }}
                                >
                                  After-sales service & repair
                                </a>{" "}
                              </li>
                              <li>
                                <a
                                  href="/en/training"
                                  style={{ fontSize: "16px" }}
                                >
                                  Training
                                </a>
                              </li>
                            </ul>
                            {/* drop down full width */}
                          </li>

                          <li>
                            <a
                              href="/en/contactus"
                              style={{ fontSize: "18px" }}
                            >
                              CONTACT US
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </nav>
            {/* menu end */}
          </centre>
        </div>
      </header>
    </div>
  );
};

export default HeaderHome_en;
